import React, { Component } from "react";

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Icon from '@material-ui/core/Icon';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { withTranslation } from 'react-i18next';

class QuotationRow extends Component {
	constructor() {
		super();
		this.state= {
			processing: false
		}
		this.handleClick = this.handleClick.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.processing = this.processing.bind(this);
	}
	
	componentDidUpdate(prevProps, prevState){
		if (prevState.processing) {
			this.setState({ processing: false });
		}
	}
	
	handleClick() {
		this.setState({processing: true});
		this.props.actions(this.props.id, this.props.processInstanceId, this.props.state);
	}
	
	processing(){
		//return <img src={"/img/loading.gif"} alt="LOADING..." />;
		return <CircularProgress color="inherit" size={20} />;
	}
	
	handleDelete(e){
		this.props.deleteProject(this.props.id);
	}
	
	render() {
		const { t } = this.props;
		let accions;
		if(this.state.processing){
			accions = this.processing();
		}else{
			if(this.props.state=="quotation_pending"){
				accions=<Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#000", cursor: "pointer"}}  onClick={() => { this.handleClick(); }}>&#59413;</Icon>;
				
			}else{
				accions="";
			}
		}
		//<a target="_blank"  href={process.env.REACT_APP_serverURL+"/documents-0.0.1/project/"+this.props.quotationId+"/quotation/pdf?access_token="+this.props.accessToken} target="_blank"><Icon style={{ fontFamily: "tipoecl", fontSize: "26px"}}>&#59415;</Icon></a>
		return (
			<TableRow key={this.props.id}>
			<TableCell>{this.props.customer}</TableCell>
			<TableCell>{this.props.code}</TableCell>
			<TableCell>{this.props.description}</TableCell>
			<TableCell>{new Intl.DateTimeFormat('es-ES', {}).format(new Date(this.props.recvd))}</TableCell>
			<TableCell>{t(this.props.state)}</TableCell>
			<TableCell>{accions}</TableCell>
			<TableCell> <a target="_blank"  href={process.env.REACT_APP_serverURL+"/documents-0.0.1/project/"+this.props.quotationId+"/quotation/pdf?access_token="+this.props.accessToken} target="_blank"><Icon style={{ fontFamily: "tipoecl", fontSize: "26px"}}>&#59415;</Icon></a> - <a target="_blank"  href={process.env.REACT_APP_serverURL+"/documents-0.0.1/project/"+this.props.quotationId+"/quotation/xlsx?access_token="+this.props.accessToken} target="_blank"><Icon style={{ fontFamily: "tipoecl", fontSize: "26px"}}>&#59416;</Icon></a></TableCell>
			<TableCell><Tooltip title="Delete"><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#c0392b", cursor: "pointer"}} onClick={() => { this.handleDelete(); }}>&#59421;</Icon></Tooltip></TableCell>
			</TableRow>
		);
	}
}

//function EditIcon(props) {
//  return (
//    <SvgIcon {...props}>
//      <path d="M2 12.88V16h3.12L14 7.12 10.88 4 2 12.88zm14.76-8.51c.33-.33.33-.85 0-1.18l-1.95-1.95c-.33-.33-.85-.33-1.18 0L12 2.88 15.12 6l1.64-1.63z" />
//    </SvgIcon>
//  );
//}

export default withTranslation() (QuotationRow);